import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISiteCEPPStatusResult, SiteCEPPConfiguration } from '../types/IActivityLog';

export class ActivityLogConnectionSetupRequest extends Request<SiteCEPPConfiguration, ISiteCEPPStatusResult> {
    constructor(params: SiteCEPPConfiguration) {
        super('configureSiteForCEPP', params);
    }
}
